import {
  useSearchParams as useSearchParams,
  useParams as useParams,
  useNavigate as useNavigate,
} from 'react-router';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { create3bks50kr3glko as create } from './CouplingRoutePropsExtentions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  split2bvyvnrlcifjv as split,
  trim11nh7r46at6sx as trim,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { useAuth0Datar84ij8t1ru66 as useAuth0Data } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/external/auth0/react/Dsl.mjs';
import { useEffect1jlgi6hiv8qwn as useEffect } from '../../../../../../kotlin-react/react/useEffect.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { MasterCommander1cpk84os63u71 as MasterCommander } from './PageProps.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_CouplingRoute() {
  _init_properties_CouplingRoute_kt__lfxxzu();
  var tmp = KProperty0();
  return CouplingRoute$delegate.f1m(null, getPropertyCallableRef('CouplingRoute', 0, tmp, _get_CouplingRoute_$ref_tjj6dw(), null));
}
var CouplingRoute$delegate;
function couplingRoute(_this__u8e3s4, path, title, rComponent) {
  _init_properties_CouplingRoute_kt__lfxxzu();
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'js.objects.unsafeJso' call
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  this_0.path = path;
  this_0.element = create(get_CouplingRoute(), rComponent, title, _this__u8e3s4);
  return this_0;
}
function appTitle() {
  _init_properties_CouplingRoute_kt__lfxxzu();
  // Inline function 'kotlin.text.trim' call
  var this_0 = split(window.document.title, ['-']).r2(0);
  return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
}
function newPathSetter(navigate) {
  _init_properties_CouplingRoute_kt__lfxxzu();
  return (path) => {
    var tmp;
    if (startsWith(path, '/')) {
      tmp = path;
    } else {
      tmp = '/' + path;
    }
    navigate(tmp);
    return Unit_instance;
  };
}
function CouplingRoute$delegate$lambda($this$nfc, props) {
  _init_properties_CouplingRoute_kt__lfxxzu();
  // Inline function 'js.array.component1' call
  var searchParams = useSearchParams().at(0);
  var params = useParams();
  var navigate = useNavigate();
  var auth0Data = useAuth0Data();
  var title = props.title;
  useEffect([title], CouplingRoute$delegate$lambda$slambda(title));
  setDefaultKey($this$nfc, '@rdk/45_10');
  var tmp2 = props.rComponent;
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$rComponent) => {
    $this$rComponent.pathParams = params;
    $this$rComponent.search = searchParams;
    $this$rComponent.commander = new (MasterCommander())(CouplingRoute$delegate$lambda$lambda$slambda($this$rComponent, auth0Data));
    $this$rComponent.config = props.config;
    return Unit_instance;
  };
  addChild($this$nfc, tmp2, block);
  // Inline function 'kotlin.js.asDynamic' call
  window.pathSetter = newPathSetter(navigate);
  return Unit_instance;
}
function CouplingRoute$delegate$lambda$slambda($title) {
  return constructCallableReference(function *($this$useEffect, $completion) {
    window.document.title = appTitle() + ' - ' + $title;
    return Unit_instance;
  }, 1);
}
function CouplingRoute$delegate$lambda$lambda$slambda($this_rComponent, $auth0Data) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = yield* $auth0Data.p3q_1($completion);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.onFailure' call
    var this_0 = tmp;
    if (Result__exceptionOrNull_impl_p6xea9(this_0) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'js.objects.unsafeJso' call
      var tmp$ret$8 = {};
      $auth0Data.m3q_1(tmp$ret$8);
    }
    // Inline function 'kotlin.getOrThrow' call
    throwOnFailure(this_0);
    return _Result___get_value__impl__bjfvqg(this_0);
  }, 0);
}
function _get_CouplingRoute_$ref_tjj6dw() {
  return constructCallableReference(() => get_CouplingRoute(), 0, 0, 283);
}
var properties_initialized_CouplingRoute_kt_u8nwxw;
function _init_properties_CouplingRoute_kt__lfxxzu() {
  if (!properties_initialized_CouplingRoute_kt_u8nwxw) {
    properties_initialized_CouplingRoute_kt_u8nwxw = true;
    CouplingRoute$delegate = nfc(CouplingRoute$delegate$lambda);
  }
}
//region block: exports
export {
  couplingRoute as couplingRoute3755chj8owe7n,
};
//endregion

//# sourceMappingURL=CouplingRoute.mjs.map
